import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

const dark = {
  primary: '#02ae9e',
  secondary: '#424242',
  accent: '#4f98ca',
  baseBackground: '#424242',
  middleBackground: '#616161', // chat & drawer
  additionalBackground: '#575757',
  alternativeBackground: '#E0E0E0',
}

const light = {
  primary: '#126f40',
  secondary: '#f0efef',
  accent: '#003174',
  baseBackground: '#FAFAFA',
  middleBackground: '#EEEEEE',
  additionalBackground: '#E0E0E0',
  alternativeBackground: '#616161'
}

Vue.mixin({
  data: () => ({
    themes: {
      dark,
      light
    },
  }), 
})

Vue.use(Vuetify, {
  theme: light,
  options: {
    customProperties: true
  },
  iconfont: 'md',
})
